import { render, staticRenderFns } from "./AIExport.vue?vue&type=template&id=36624a1e"
import script from "./AIExport.vue?vue&type=script&lang=js"
export * from "./AIExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports